import { createContext } from "react";
export const LoaderContext = createContext(false);
export const UserContext = createContext({});
export const MobileNav = createContext(false);
export const SelectedChatContext = createContext("");
export const ReplyContext = createContext(null);
export const CreateJoinContext = createContext(null);
